// AI Generated Test
import { Component, Input } from '@angular/core';
import { MonEventService } from '@monsido/services/mon-event/mon-event.service';
import { MON_EVENTS } from '@monsido/core/constants/mon-events.constant';
import {
    PageDetailsSeoPagesPagesDialogComponent,
} from '@client/app/components/pagedetails/details/sections/seo/seo-information/pages/page-details-seo-pages-dialog.component';

@Component({
    selector: 'seo-information-duplicate-h1',
    standalone: false,
    template: `
        <p translate>H1 on this page</p>

        <ol>
            <li *ngFor="let headline of seo.content; trackBy: trackByIndex" class="py-1">
                <div class="d-flex align-items-center">
                    <div class="mr-auto">
                        {{ headline }}
                    </div>
                    <div>
                        <button class="btn btn-border-radius btn-secondary"
                                type="button"
                                (click)="seePages(headline)"
                                translate>
                            See pages
                        </button>
                    </div>
                </div>
            </li>
        </ol>
    `,
})
export class SeoInformationDuplicateH1Component {
    @Input() seo: any;

    constructor (private monEventService: MonEventService) {}

    seePages (headline: any): void {
        const params = {
            body: PageDetailsSeoPagesPagesDialogComponent,
            size: 'lg',
            data: {
                seo: this.seo,
                title: headline,
            },
        };
        this.monEventService.run(MON_EVENTS.LOAD_DIALOG, { params });
    }

    trackByIndex (index: number, item: any): number {
        return index;
    }
}
